import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IoRouterLink = _resolveComponent("IoRouterLink")!

  return (_openBlock(), _createElementBlock("nav", {
    id: "sidebar",
    class: _normalizeClass({'open': _ctx.isOpen})
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (menuItem, inx) => {
      return (_openBlock(), _createBlock(_component_IoRouterLink, {
        key: inx,
        "link-url": menuItem.url,
        "link-target": menuItem.target,
        "link-title": menuItem.titleAttr,
        onClick: _ctx.toggleSidebar
      }, {
        default: _withCtx(() => [
          (menuItem.icon !== null)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "sidebar__icon",
                style: _normalizeStyle(`background-image: url('${menuItem.icon}')`)
              }, null, 4))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: "sidebar__label",
            innerHTML: menuItem.title
          }, null, 8, _hoisted_1)
        ]),
        _: 2
      }, 1032, ["link-url", "link-target", "link-title", "onClick"]))
    }), 128))
  ], 2))
}